import { Button, Flex, Loader } from "@mantine/core";
import { modals } from "@mantine/modals";

import LocationForm from "./LocationForm";
import {
  useCreateEventLocation,
  useDeleteEventLocation,
  useGetLocation,
  usePatchEventLocation,
} from "../../../api/event";
import { useDeleteConfirm } from "../../../hooks/useDeleteConfirm";

function CreateLocation({ event }) {
  const { mutate, isPending } = useCreateEventLocation(event.id);

  const onSubmit = (data) => {
    mutate(data, {
      onSuccess: () => {
        modals.closeAll();
      },
    });
  };

  return (
    <Flex direction="column">
      <LocationForm
        onSubmit={onSubmit}
        event={event}
        formId="create-location"
      />
      <Button type="submit" form="create-location" loading={isPending} mt="sm">
        Create
      </Button>
    </Flex>
  );
}

export const openCreateLocationModal = (event) => {
  modals.open({
    title: "Create Location",
    children: <CreateLocation event={event} />,
  });
};

const EditLocation = ({ event, locationId }) => {
  const eventId = event.id;
  const { data: location, isPending } = useGetLocation(eventId, locationId);

  const { mutate, isPending: isMutating } = usePatchEventLocation(
    eventId,
    locationId
  );

  if (isPending) {
    return <Loader mt={10} />;
  }

  const onSubmit = (data) => {
    mutate(data, { onSettled: () => modals.closeAll() });
  };

  return (
    <Flex direction="column">
      <LocationForm
        onSubmit={onSubmit}
        event={event}
        formId="edit-location"
        location={location}
      />
      <Button type="submit" form="edit-location" loading={isMutating} mt="sm">
        Save
      </Button>
    </Flex>
  );
};

export const openEditLocationModal = (event, locationId) => {
  modals.open({
    title: "Edit Location",
    children: <EditLocation locationId={locationId} event={event} />,
  });
};
